/**
 * 전역 하단 토스트(찜 등) — 아래에서 올라왔다 내려가는 네이티브식.
 *  networkActivity 와 동일한 구독형 스토어. AppToastHost 가 App 루트에서 렌더.
 */
let listeners = new Set();
let current = null;
let hideTimer = null;

export function subscribeToast(fn) {
  listeners.add(fn);
  fn(current);
  return () => listeners.delete(fn);
}

export function showToast(message, duration = 2000) {
  current = { message, key: Date.now() };
  listeners.forEach((fn) => fn(current));
  clearTimeout(hideTimer);
  hideTimer = setTimeout(() => {
    current = null;
    listeners.forEach((fn) => fn(null));
  }, duration);
}
